<template>
<el-form-item prop="hgt1" label="高度" :rules="[{
  required: true,
  message: '请输入高度'
}]">
  <el-radio-group v-model="hgt1Value" @change="onHgt1ValueChange">
    <el-radio
      v-for="height in heights"
      :key="height.value"
      :label="height.value"
    >{{height.label}}</el-radio>
    <div style="margin-top:10px;">
      <el-radio label="" class="custom-height-radio">
        <el-input v-model="hgt1Input" type="number" :disabled="!!hgt1Value" style="width:233px;" @change="onHgt1InputChange">
          <template #append>米</template>
        </el-input>
      </el-radio>
    </div>
  </el-radio-group>
</el-form-item>
</template>

<script>
import Option from './Option'
import BaseHySplit from './BaseHySplit'

const {heights} = Option

export default {
  name: 'HeightRadioGroup',
  extends: BaseHySplit,
  data: () => ({
    hgt1Value: heights[0].value,
    hgt1Input: 2000
  }),
  computed: {
    heights: () => heights
  },
  methods: {
    onHgt1ValueChange (hgt1Value) {
      if (hgt1Value) {
        this.model.hgt1 = hgt1Value
      } else {
        this.onHgt1InputChange()
      }
    },
    onHgt1InputChange () {
      let hgt1Input = parseInt(this.hgt1Input)
      this.model.hgt1 = Number.isFinite(hgt1Input) ? hgt1Input : ''
    }
  },
  created () {
    this.onHgt1ValueChange(heights[0].value)
  }
}
</script>

<style lang="scss" scoped>
.custom-height-radio {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/HeightRadioGroup.vue